import React from 'react'
import { toast } from 'react-toastify'
import NotificationAlert from '../components/NotificationAlert'
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined'
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined'
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined'
import BlockOutlinedIcon from '@material-ui/icons/BlockOutlined'
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser'
import PauseCircleFilledIcon from '@material-ui/icons/PauseCircleFilled'

import CheckCircleTwoToneIcon from '@material-ui/icons/CheckCircleTwoTone'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ReportProblemIcon from '@material-ui/icons/ReportProblem'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import CancelIcon from '@material-ui/icons/Cancel'
import AutorenewIcon from '@material-ui/icons/Autorenew'

export const DisplayFormikState = (props) => {
  return (
    <div style={{
      position: 'sticky',
      top: 75.67,
      zIndex: 10
    }}>
      <pre
        style={{
          background: '#f6f8fa',
          padding: '.5rem',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          margin: 0
        }}
      >
      <strong>props</strong> ={' '}
        {JSON.stringify(props, null, 2)}
    </pre>
    </div>
  )
}

/**
 * Log function works only in development and removed in production
 * @param args
 */
export const log = (...args) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(...args)
  }
}

export const randomKey = Math.random().toString(36).substr(2, 9)

export const isEmpty = (object) => {
  return !Object.getOwnPropertySymbols(object).length && !Object.getOwnPropertyNames(object).length
}


/**
 * notificationProps: {
 *  type: `One of: 'e-commerce','notification','offer', 'info','message','feedback','customer','shipped','done'
                    'delivered','defence','report','upload','disc'`
 *  message: message,
 *  color: `One of theme colors: 'error', 'success', 'info' , 'warning' ... etc
 * }
 * Set the toastType.
 * `One of: 'info', 'success', 'warning', 'error', 'default'`
 */
export const handleNotificationAlert = (notificationProps, toastType) => {
  return toast(
    <NotificationAlert
      {...notificationProps}
      variant='contained'
      className={'notification-component'}
    />,
    {
      type: toastType,
      position: toast.POSITION.BOTTOM_LEFT,
      progressClassName: 'notification-progress-wrapper',
      className: 'notification-wrapper'
    }
  )
}

/** Method to Filter the Empty params before send the API Request.
 *
 * @param data
 * @param noZeros
 * @returns {{}}
 */
export const filterData = (data, noZeros, keepArrays) => {
  if (data instanceof FormData) {
    return data
  } else {
    let newData = {}
    Object.keys(data).forEach((key => {
      const isString = typeof data[key] === 'string' && data[key].length
      const isArray = Array.isArray(data[key]) && (!!keepArrays || data[key].length)
      const isObject = typeof data[key] === 'object' && !!Object.keys(data[key] || {}).length
      const isNumber = !!noZeros ? (!!data[key] && Number.isInteger(data[key])) : Number.isInteger(data[key])
      const isDate = data[key] instanceof Date
      const isBoolean = typeof data[key] === 'boolean' && data[key] === !!data[key]
      if (isString || isArray || isNumber || isBoolean || isObject) {
        newData[key] = data[key]
      }
      if (isDate) {
        let date = new Date(data[key])
        let dd = String(date.getDate()).padStart(2, '0')
        let mm = String(date.getMonth() + 1).padStart(2, '0') //January is 0!
        let yyyy = date.getFullYear()
        newData[key] = dd + '-' + mm + '-' + yyyy
      }
    }))
    return newData
  }
}

export const parseLocaleNumber = (num) => {
  // Detect the user's locale decimal separator:
  let decimalSeparator = (1.1).toLocaleString().substring(1, 2)
  // Detect the user's locale thousand separator:
  let thousandSeparator = (1000).toLocaleString().substring(1, 2)
  // In case there are locales that don't use a thousand separator
  if (thousandSeparator.match(/\d/))
    thousandSeparator = ''

  num = num.replace(thousandSeparator, '').replace(decimalSeparator, '.')

  return parseFloat(num)
}

export const formatPhoneNumber = (str) => {
  if (!!str) {
    let match = str.replace(/ /g, '').match(/.{1,3}/g)
    match[0] = '(' + match[0] + ')'
    return match.reduce((previous, current, index, array) => {
      if (index > 3) {
        return previous + '' + current
      } else {
        return previous + ' ' + current
      }
    })
  }
}
export const concatBranchAddress = (AddressObj) => {
  let address = ''
  if (!!Object.keys(AddressObj || {}).length) {
    address = [[(AddressObj.room || ''), (AddressObj.floor || ''), (AddressObj.buildingNumber || '')]?.filter(text => !!text?.trim())?.join(' - '),
      [(AddressObj.street || ''), (AddressObj.landmark || '')]?.filter(text => !!text?.trim())?.join(' - '),
      [(AddressObj.regionCity || ''), (AddressObj.governate || ''), (AddressObj.country || ''), (AddressObj.postalCode || '')]?.filter(text => !!text?.trim())?.join(' - '),
      (AddressObj.additionalInformation || '')
    ]?.filter(text => !!text?.trim())?.join('\n')
    // address = [`${AddressObj.buildingNumber || ''} ${AddressObj.street || ''}`.trim(),
    //   AddressObj.regionCity || '',
    //   AddressObj.governate || '',
    //   AddressObj.countryName || ''
    // ].filter(text => !!text.trim()).join(' - ')
  }
  return address
}
export const concatReceiverBranchAddress = (AddressObj) => {
  let address = ''
  if (!!Object.keys(AddressObj || {}).length) {
    address = [`${AddressObj.building_number?.trim() || ''} ${AddressObj?.street_name?.trim() || ''}`?.trim(),
      AddressObj?.city || '',
      AddressObj?.governorate || '',
      AddressObj?.country || ''
    ]?.filter(text => !!text?.trim())?.join(' - ')
  }
  return address
}


export const calculateDecimal = (num) => {
  let value = num?.toString()
  if (!!value) {
    let values = value?.split('.')
    if (!!values?.length && !!values[1]) {
      if (values[1]?.length > 5) {
        value = parseFloat(value).toFixed(5)
      } else if (values[1]?.length > 2) {
        value = parseFloat(value)
      } else {
        value = parseFloat(value).toFixed(2)
      }
    } else {
      value = parseFloat(value).toFixed(2)
    }
    value = (parseFloat(value) === parseInt(value)) ? parseFloat(value).toFixed(2) : parseFloat(value)
  }
  return value
}

export const getStatusIcon = (status, fill, freeze) => {
  switch (status) {
    case 'Valid':
    case 'Approved':
    case 'complete':
      return !!freeze ? <CheckCircleTwoToneIcon/> : (!!fill ? <CheckCircleIcon/> : <CheckCircleOutlineOutlinedIcon/>)
    case 'Invalid':
      return !!fill ? <ReportProblemIcon/> : <ReportProblemOutlinedIcon/>
    case 'Cancelled':
    case 'deleted':
      return !!fill ? <DeleteForeverIcon/> : <DeleteForeverOutlinedIcon/>
    case 'Rejected':
    case 'error':
      return !!fill ? <CancelIcon/> : <BlockOutlinedIcon/>
    case 'Submitted':
    case 'InProgress':
      return <VerifiedUserIcon/>
    case 'PENDING':
      return <PauseCircleFilledIcon/>
    case 'Mixed':
      return <AutorenewIcon/>
    default:
      return ''
  }
}

export const arrangeCodeData = (data, requesterTaxpayer, ownerTaxpayer, status, reuse) => {
  let newData = {}
  if (!!Object.keys(data || {}).length) {
    newData = {
      details: {
        codeID: data?.codeID || '',
        codeType: data?.codeTypeName || '',
        itemCode: data?.itemCode || '',
        codeName_en: data?.codeName || data?.codeNamePrimaryLang || '',
        codeName_ar: data?.codeNameAr || data?.codeNameSecondaryLang || '',
        description_en: data?.description || data?.descriptionPrimaryLang || '',
        description_ar: data?.descriptionAr || data?.descriptionSecondaryLang || '',
        category: data?.codeCategorization || '',
        linkedCode: data?.linkedCode || '',
        activeFrom: data?.activeFrom || '',
        activeTo: data?.activeTo || '',
        active: data?.active || '',
        status: data?.status || status || '',
        statusReason: data?.statusReason || '',
        created_at: data?.creationDateTimeUTC || data?.codeCreationDateTimeUtc || '',
        updated_at: data?.lastModificationDateTimeUTC || ''
      },
      parentCategory: !reuse ? {
        codeID: data?.parentCodeID || '',
        itemCode: data?.parentItemCode || '',
        codeName_en: data?.parentCodeName || data?.parentCodeNamePrimaryLang || '',
        codeName_ar: data?.parentCodeNameAr || data?.parentCodeNameSecondaryLang || '',
        description_en: data?.parentDescription || '',
        description_ar: data?.parentDescriptionAr || '',
        category: data?.parentCodeCategorization || '',
        activeFrom: data?.parentActiveFrom || '',
        activeTo: data?.parentActiveTo || '',
        active: data?.active || ''
      } : {},
      attributes: getAttributes(data?.attributes),
      requesterTaxpayer: filterData(requesterTaxpayer || {}) || {},
      ownerTaxpayer: filterData(ownerTaxpayer || {}) || {}
    }
  }
  return newData
}

const getAttributes = (data) => {
  let attributes = {}
  if (!!data?.length) {
    data.forEach(attr => {
      attributes = { ...attributes, [attr?.codeAttributeKey]: attr?.codeAttributeValue }
    })
  }
  return attributes
}
export const arrangePackageData = (data) => {
  let newData = {}
  if (!!Object.keys(data || {}).length) {
    newData = {
      details: {
        packageId: data?.packageId || '',
        submissionDate: data?.submissionDate || '',
        type: data?.type || '',
        format: data?.format || '',
        requestorType: data?.requestorTypeId || '',
        requestorTaxpayerName: data?.requestorTaxpayerName ? <div className={'cellDataWrapper'}>
          <strong>{data?.requestorTaxpayerName}</strong>
          {!!data?.requestorTaxpayerRIN && <span>{data?.requestorTaxpayerRIN}</span>}
        </div> : '',
        status: data?.status || '',
        deletionDate: data?.deletionDate || ''
      },
      queryParameters: data?.queryParams || {}
    }
  }
  return newData
}

export const getQuarterDate = (quarter, year, isEnd) => {
  return new Date(!!isEnd ? `${year}-${String(quarter * 3).padStart(2, '0')}-31` : `${year}-${String((quarter * 3) - 2).padStart(2, '0')}-01`)
}